import { Image, LI, UL } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../Service";
import { ActiveOrderProps } from "../../../../Type/Dashboard/CryptoDashboardType";

const ActiveOrderUserDetails = ({data}:ActiveOrderProps) => {
  return (
    <div className="user-details customers">
      <UL className="flex-row simple-list">
        {data.images.map((item, i) => (
          <LI className="d-inline-block" key={i}>
            <Image
              className="rounded-circle"
              src={dynamicImage(`dashboard/user/${item}`)}
              alt="user"
            />
          </LI>
        ))}
      </UL>
    </div>
  );
};

export default ActiveOrderUserDetails;
